/* unplugin-vue-components disabled */import script from "./customerAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./customerAdd.vue?vue&type=script&lang=ts&setup=true"

import "./customerAdd.vue?vue&type=style&index=0&id=ef29cc38&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef29cc38"]])

export default __exports__